import {CancelReason} from '../services/cancel-activity.service';
export class MyEventsAction {
  static readonly type = '[MyEvents] Add item';

  constructor(public payload: string) {
  }
}

export class LoadMyNextEventsAction {
  static readonly type = '[MyEvents] LoadMyNextEventsAction';
}

export class LoadMyPastEventsAction {
  static readonly type = '[MyEvents] LoadMyPastEventsAction';
}
export class LoadMyCancelEventsAction {
  static readonly type = '[MyEvents] LoadMyCancelEventsAction';
}

export class DeleteMyEventsAction {
  static readonly type = '[MyEvents] DeleteMyEventsAction';

  /** SMA-100: why, and the word left for the people registered. */
  constructor(
    public eventId: string,
    public reason?: CancelReason,
    public reasonCustomText?: string,
  ) {
  }
}
